$(function () {
	const tables = $("table");
	tables.each((ind, el) => {
		var table = $(el);
		if (!table.parent().hasClass('table-responsive')) {
			table.wrap('<div class="table-responsive"></div>')
		}
	})
})